export function isAppleWebKit() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    (/Safari/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|Android/.test(navigator.userAgent));
}

export function createAudioRecorder(stream) {
  const mp4 = ['audio/mp4;codecs=mp4a.40.2', 'audio/mp4'];
  const webm = ['audio/webm;codecs=opus', 'audio/webm'];
  // AAC/MP4 is the stable native iPhone/Safari path. Do not prefer newly
  // advertised WebM support over AAC on iOS/Home Screen installations.
  const formats = isAppleWebKit() ? [...mp4, ...webm] : [...webm, ...mp4];
  for (const mimeType of formats) {
    if (!MediaRecorder.isTypeSupported(mimeType)) continue;
    try { return { recorder: new MediaRecorder(stream, { mimeType }), requestedMime: mimeType }; }
    catch { /* A capability claim can still fail at construction; try next. */ }
  }
  return { recorder: new MediaRecorder(stream), requestedMime: 'browser-default' };
}

export async function assembleRecording(chunks, recorderMime) {
  const nonempty = chunks.filter(chunk => chunk.size > 0);
  const reported = nonempty.find(chunk => chunk.type)?.type || recorderMime || '';
  let blob = new Blob(nonempty, reported ? { type: reported } : undefined);
  if (!blob.size) return { blob, extension: null, mimeType: reported, chunkCount: 0 };
  const header = new Uint8Array(await blob.slice(0, 16).arrayBuffer());
  const ascii = (start, end) => String.fromCharCode(...header.slice(start, end));
  let mimeType = reported.split(';')[0].toLowerCase(), extension;
  // Trust the actual container, not only the constructor's requested MIME.
  if (ascii(4, 8) === 'ftyp') mimeType = 'audio/mp4';
  else if (header[0] === 0x1a && header[1] === 0x45 && header[2] === 0xdf && header[3] === 0xa3) mimeType = 'audio/webm';
  else if (ascii(0, 4) === 'RIFF' && ascii(8, 12) === 'WAVE') mimeType = 'audio/wav';
  else if (ascii(0, 4) === 'OggS') mimeType = 'audio/ogg';
  else if (ascii(0, 4) === 'fLaC') mimeType = 'audio/flac';
  extension = ({ 'audio/mp4': 'm4a', 'video/mp4': 'm4a', 'audio/webm': 'webm', 'video/webm': 'webm', 'audio/ogg': 'ogg', 'audio/wav': 'wav', 'audio/x-wav': 'wav', 'audio/flac': 'flac', 'audio/mpeg': 'mp3' })[mimeType];
  if (mimeType) blob = new Blob(nonempty, { type: mimeType });
  return { blob, extension, mimeType, chunkCount: nonempty.length };
}